<template>
  <div>
    <h3 class="margin-bottom-30">
      {{ event.name }}
    </h3>

    <StartupList
      v-loading="startupsFetchInProgress"
      :fetch-filters="{ event_id: eventId }"
      :showroom-id="eventId"
    />
  </div>
</template>

<script>
import StartupList from 'modules/startup-list/StartupList.vue'
import { mapState } from 'vuex'

export default {
  components: { StartupList },
  props: {
    eventId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    ...mapState({
      event: (s) => s.eventDetails.event,
      startups: (s) => s.startupList.startups,
      startupsFetchInProgress: (s) => s.startupList.fetchInProgress,
    }),
  },
  created() {
    const eventId = this.eventId
    this.$store.dispatch('eventDetails/visit', { eventId: this.eventId })
  },
}
</script>
